import { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Typography, Spacing, Tabs } from '@taleemabad/dsm/components';
import { mq, BreakpointSizes } from '@taleemabad/dsm/themes';

// Styled Components
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--rk-spacing-xl);
  margin: 0 auto;
  max-width: 1200px;

  ${mq(BreakpointSizes.xs)} {
    padding: var(--rk-spacing-sm);
  }
`;

const HeaderSection = styled.div`
  margin-bottom: var(--rk-spacing-xxxl);

  ${mq(BreakpointSizes.xs)} {
    margin-bottom: var(--rk-spacing-xxl);
  }
`;

// Interfaces
export interface TabItem {
  key: number;
  label: string;
}

interface FlnBaselineAssessmentTemplateProps {
  tabs: TabItem[];
  activeTab: number;
  onTabChange: (tabId: number) => void;
  tabContent: ReactNode;
  title?: string;
  description?: string;
}

export const FlnBaselineAssessmentTemplate: FC<
  FlnBaselineAssessmentTemplateProps
> = ({
  tabs,
  activeTab,
  onTabChange,
  tabContent,
  title = 'FLN Baseline Assessment',
  description = 'Select a tab below to view the question paper or access answer key tasks',
}) => {
  return (
    <ContentContainer>
      <HeaderSection>
        <Typography variant="textTitleLarge">{title}</Typography>
        <Spacing marginTop="sm" />
        <Typography variant="textBodyMediumOnSurfaceVariant">
          {description}
        </Typography>
      </HeaderSection>

      <Spacing marginBottom="xxl">
        <Tabs
          variant="secondary"
          activeTabKey={activeTab}
          tabs={tabs}
          onChange={onTabChange}
        />
      </Spacing>

      {tabContent}
    </ContentContainer>
  );
};
